
import mutations from '../../general/mutations';
import currentMutations from './mutations';
import { DataService } from '../../../../src/config/dataService/dataService';


const state = () => ({
    list: [],
    currentService: {},
    loading: false,
    message: '',
});
// declare actions
const actions = {

    async getAllServices({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Services/GetAllServices`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_SERVICES', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async addService({ commit }, service) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Services/AddService`, service);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async editService({ commit }, service) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Services/UpdateService`, service);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async changeServiceStatus({ commit },serviceId) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Services/ChangeServiceStatus`,{},{
                id:serviceId
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async setServices({ commit }, services) {
        try {
            await commit('SET_SERVICES', services);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentServiceToView({ commit },service) {
        await commit('axiosStart');
        await commit('SET_CURRENT_SERVICE',service);
        await commit('axiosSuccess');
        return true
    },
    // Coverage Photos
    async getAllCoveragePhotos({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Services/GetAllCoveragePhotos`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_COVERAGE_PHOTOS', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async addCoveragePhoto({ commit }, coveragePhoto) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Services/AddCoveragePhoto`, coveragePhoto);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token
    
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async editCoveragePhoto({ commit }, coveragePhoto) {
    
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Services/UpdateCoveragePhoto`, coveragePhoto);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token
    
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async changeCoveragePhotoStatus({ commit },coveragePhotoId) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Services/ChangeCoveragePhotoStatus`,{},{
                id:coveragePhotoId
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async setCoveragePhotos({ commit }, coveragePhotos) {
        try {
            await commit('SET_COVERAGE_PHOTOS', coveragePhotos);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentCoveragePhotoToView({ commit },coveragePhoto) {
        await commit('axiosStart');
        await commit('SET_CURRENT_COVERAGE_PHOTO',coveragePhoto);
        await commit('axiosSuccess');
        return true
    },

    


};

export default {
    namespaced: false,
    state,
    actions,
    mutations: { ...currentMutations, ...mutations }
};
